import { EULAprops } from '@usacsmideo/types';

export const EULASectionText = (props: EULAprops) => {
  return <p className="ml-5 text-sm font-semibold">{props.text}</p>;
};
